import { useQuery } from "@tanstack/react-query";
import { getProjectIssues } from "../api/timeEntryApi";
import { timeEntryKeys } from "../api/timeEntryKeys";

// Obtiene las issues Redmine de un proyecto.
// Solo se ejecuta cuando projectId es un valor positivo válido. `watch("projectId")` devuelve
// el valor crudo del form: el id numérico del <MenuItem>, o undefined/"" antes de elegir
// proyecto (yup recién lo castea a string al enviar). `Number(...)` reemplaza la comparación
// `projectId > 0` original: TS no permite `>` entre `string | number` y `number`, pero la
// comparación relacional de JS ya coaccionaba con el mismo algoritmo que `Number()`, así que
// el resultado en runtime no cambia.
export const useProjectIssues = (projectId: number | string | undefined) =>
  useQuery({
    queryKey: timeEntryKeys.projectIssues(projectId),
    // `enabled` impide que la query corra sin projectId válido, así que dentro de
    // queryFn ya no puede ser undefined.
    queryFn: () => getProjectIssues(projectId!),
    enabled: Boolean(projectId) && Number(projectId) > 0,
  });
